import { combineReducers } from "redux";
import { createItemReducer } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

/*
Monolit.Personal:WorkHoliday:WorkHoliday_ListForPersTotalsPo;
Monolit.Personal:WorkHolidayOrder:WorkHoliday_ListForPersPo;
 */

/*
CompHolidayApp.ListPO – список
CompHolidayApp.NewPO – создать
CompHolidayApp.DelPO – удалить
CompHolidayApp.PrintPO - печать
*/

export function dayOffReducer() {
    return combineReducers({
        WorkHoliday_ListForPersTotalsPo: createItemReducer("DayOff", "WorkHoliday.ListForPersTotalsPoNew", false),
        WorkHoliday_ListForPersPo: createItemReducer("DayOff", "WorkHoliday.ListForPersPoNew", false),
        CompHolidayApp_ListPO: createItemReducer("DayOff", "CompHolidayApp.ListPO", false),
        CompHolidayApp_NewPO: createItemReducer("DayOff", "CompHolidayApp.NewPO", false),
        CompHolidayApp_DelPO: createItemReducer("DayOff", "CompHolidayApp.DelPO", false),
        CompHolidayApp_PrintPO: createItemReducer("DayOff", "CompHolidayApp.PrintPO", false),

        CompHolidayApp_ListExPO: createItemReducer("DayOff", "CompHolidayApp.ListExPO", false),
        CompHolidayApp_GetData: createItemReducer("DayOff", "CompHolidayApp.GetData", false),
        CompHolidayApp_Send: createItemReducer("DayOff", "CompHolidayApp.Send", false)
    });
}